<template>
  <div>
    <v-data-table
      v-bind="$attrs"
      :headers="tableHeaders"
      :items="tableData"
      :items-per-page="15"
      :search="search"
      mobile-breakpoint="930"
      class="elevation-1"
    >
      <template v-slot:top>
        <div class="d-flex pa-4">
          <span class="headline primary--text font-weight-medium">
            <v-icon class="primary--text" left>{{ icon }}</v-icon
            >{{ title }}
          </span>
          <v-spacer></v-spacer>
          <v-slide-x-reverse-transition>
            <v-text-field
              v-show="showSearch"
              class="ma-0 pa-0"
              v-model="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-slide-x-reverse-transition>
          <v-icon class="ma-0 mr-4 pa-0" @click="showSearch = !showSearch"
            >mdi-magnify</v-icon
          >
          <v-dialog v-model="showFormDialog" max-width="850px">
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="disable"
                v-bind="headerButtonSize"
                color="primary"
                v-on="on"
              >
                <v-icon left>mdi-plus</v-icon>Add
              </v-btn>
            </template>
            <v-card>
              <component :is="formComponent" v-bind="formProps" />
            </v-card>
          </v-dialog>
        </div>
      </template>
      <template v-slot:group.header="props">
        <td class="text-start" :colspan="props.headers.length">
          <span>
            <v-icon v-if="groupIcon" left>{{ groupIcon }}</v-icon>
            {{ props.group }}
          </span>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          :disabled="disable"
          :size="iconSize"
          class="mr-2"
          @click="editEntity(item)"
          >mdi-pencil</v-icon
        >
        <v-icon
          :disabled="disable"
          :size="iconSize"
          @click.stop="openDeleteDialog(item)"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
    <ConfirmDialog
      v-model="showDeleteDialog"
      :onConfirmClick="deleteEntity"
      :onCloseClick="closeDeleteDialog"
      description="Are you sure you want to delete this item?"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import ResponsiveSizeHelperMixin from '../../mixins/ResponsiveSizeHelperMixin';
import LocationsForm from './LocationsForm.vue';
import ActivitiesForm from './ActivitiesForm.vue';
import VesselForm from './VesselForm.vue';
import BulkForm from './BulkForm.vue';
import TankForm from './TankForm.vue';
import ClientForm from './ClientForm.vue';
import ConfirmDialog from '../ui/ConfirmDialog.vue';

export default {
  inheritAttrs: false,
  props: {
    title: String,
    icon: String,
    tableHeaders: Array,
    tableData: Array,
    formComponent: String,
    disable: {
      type: Boolean,
      required: false,
    },
    groupIcon: {
      type: String,
      required: false,
    },
  },
  components: {
    LocationsForm,
    ActivitiesForm,
    VesselForm,
    BulkForm,
    TankForm,
    ClientForm,
    ConfirmDialog,
  },
  data() {
    return {
      showFormDialog: false,
      showDeleteDialog: false,
      entity: {},
      edit: false,
      showSearch: false,
      search: '',
      bus: new Vue(),
    };
  },
  mixins: [ResponsiveSizeHelperMixin],
  computed: {
    formProps() {
      return {
        edit: this.edit,
        entity: this.entity,
        onCloseClick: this.closeFormDialog,
        onSubmitClick: this.saveEntity,
        bus: this.bus,
      };
    },
  },
  watch: {
    showFormDialog(newVal) {
      if (!newVal) {
        this.closeFormDialog();
      }
    },
  },
  methods: {
    saveEntity() {
      this.$emit('submit', this.entity, this.edit);
    },
    editEntity(item) {
      this.entity = { ...item };
      this.edit = true;
      this.showFormDialog = true;
    },
    deleteEntity() {
      this.$emit('delete', this.entity.id);
      this.closeDeleteDialog();
    },
    resetForm() {
      this.entity = {};
      this.bus.$emit('resetForm');
    },
    closeFormDialog() {
      this.entity = {};
      this.resetForm();
      this.edit = false;
      this.showFormDialog = false;
    },
    openDeleteDialog(item) {
      this.entity = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.entity = {};
      this.showDeleteDialog = false;
    },
  },
};
</script>

<style>
</style>
